import axios from "axios";
import { handleRuntimeAccessError } from "./runtimeAccess";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const PARENT_API = `${BACKEND}/api`;

// Parent session is carried by the httpOnly `parent_access_token` cookie — a distinct
// cookie name from staff/student so all three sessions can coexist in one browser.
const papi = axios.create({ baseURL: PARENT_API, withCredentials: true });

papi.interceptors.response.use(
  (response) => response,
  (error) => {
    handleRuntimeAccessError(error);
    return Promise.reject(error);
  }
);

export default papi;
